module.exports = __webpack_public_path__ + "img/manzana.cd53bc4e.svg";